module.exports = __webpack_public_path__ + "static/img/14000518.3bb3a228.png";